// extracted by mini-css-extract-plugin
export default {"featuresHeader":"FeaturesHeaderSection_featuresHeader__uWqLZ","container":"FeaturesHeaderSection_container__xtXQM","headline":"FeaturesHeaderSection_headline__5SC6k"};